import { render } from "./LogrosEN.vue?vue&type=template&id=58e9730a&scoped=true"
import script from "./LogrosEN.vue?vue&type=script&lang=js"
export * from "./LogrosEN.vue?vue&type=script&lang=js"

import "./LogrosEN.vue?vue&type=style&index=0&id=58e9730a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e9730a"]])

export default __exports__